module.exports = __webpack_public_path__ + "img/aniImg2.ce153fd5.png";